import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import gsap from "gsap";
import { SITE } from "@/data/site";

const H1_LINES = ["Redonnez à votre", "façade sa première", "jeunesse."];

export const Hero = () => {
  const rootRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const mm = gsap.matchMedia();
      mm.add("(prefers-reduced-motion: no-preference)", () => {
        const tl = gsap.timeline({ defaults: { ease: "power3.out" } });
        tl.fromTo(".hero-line-inner", { y: "110%" }, { y: "0%", duration: 0.9, stagger: 0.12 })
          .fromTo(".hero-fade", { y: 24, opacity: 0 }, { y: 0, opacity: 1, duration: 0.5, stagger: 0.1 }, "-=0.35");
      });
      mm.add("(prefers-reduced-motion: reduce)", () => {
        gsap.set([".hero-line-inner", ".hero-fade"], { opacity: 1, y: "0%" });
      });
    }, rootRef);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={rootRef} className="relative overflow-hidden" data-testid="hero-section">
      {/* TODO: remplacer par une vraie photo de chantier Brandon dès que disponible.
          En attendant : photo libre de droits (CC BY-SA 4.0, Père Igor / Wikimedia Commons)
          d'une maison en pierre à toit de tuiles, cohérente avec l'architecture du Périgord —
          voir crédit dans le footer. */}
      <img
        src="/hero-roof.jpg"
        srcSet="/hero-roof-mobile.jpg 900w, /hero-roof.jpg 1920w"
        sizes="100vw"
        alt="maison en pierre à toit de tuiles en Dordogne - ravalement façade Périgord - HRC Rénovation"
        className="absolute inset-0 w-full h-full object-cover"
        fetchpriority="high"
      />
      <div
        className="absolute inset-0"
        style={{ background: "linear-gradient(100deg, rgba(10,37,64,0.94) 0%, rgba(10,37,64,0.82) 45%, rgba(10,37,64,0.45) 100%)" }}
        aria-hidden="true"
      />
      <div className="relative max-w-site mx-auto px-5 lg:px-6 pt-[120px] lg:pt-[96px] min-h-[min(88vh,780px)] flex items-center">
        <div className="max-w-[720px] py-16 lg:py-24">
          <h1
            className="font-heading font-bold text-[40px] leading-[1.05] sm:text-5xl lg:text-[64px] text-white"
            style={{ letterSpacing: "-0.03em" }}
            data-testid="hero-title"
          >
            {H1_LINES.map((line, i) => (
              <span key={i} className="line-mask">
                <span className="hero-line-inner block" style={{ transform: "translateY(110%)" }}>{line}</span>
              </span>
            ))}
          </h1>

          <p className="hero-fade mt-6 text-lg text-white/85 max-w-[560px]" style={{ opacity: 0 }}>
            Ravalement, nettoyage hydrofuge et peinture en Dordogne, Lot et sud Limousin. Un artisan avec 10 ans d'expérience. Devis gratuit sous 48h.
          </p>

          <div className="hero-fade mt-9 flex flex-col sm:flex-row gap-4" style={{ opacity: 0 }}>
            <Link to="/devis" className="btn-base btn-metal w-full sm:w-auto" data-testid="hero-devis-btn">
              Obtenir mon devis gratuit
              <ArrowRight size={18} aria-hidden="true" />
            </Link>
            <a href={SITE.phoneHref} className="btn-base btn-outline-white w-full sm:w-auto tnum" data-testid="hero-phone-btn">
              <Phone size={18} aria-hidden="true" />
              {SITE.phone}
            </a>
          </div>

          <p className="hero-fade mt-6 text-[13px] font-medium text-white/70" style={{ opacity: 0 }}>
            Devis gratuit · Déplacement offert · Sans engagement
          </p>
        </div>
      </div>
    </section>
  );
};
